/*
 * Steps messages
 *
 * This contains all the text for the Steps component
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  address: {
    id: 'components.Steps.address',
    defaultMessage: 'Address',
  },
  shipping: {
    id: 'common.titles.shippingMethod',
    defaultMessage: 'Shipping method',
  },
  review: {
    id: 'components.Steps.review',
    defaultMessage: 'Review Order',
  },
  payment: {
    id: 'components.Steps.payment',
    defaultMessage: 'Pay & Confirm',
  },
});
